<script>
import { content } from "./PricingHero";

</script>

<section class="PricingHero">
  <div class="PricingHero__container">
    <h1 class="PricingHero__title">{content.title}</h1>
    <p class="PricingHero__subtitle">{content.subtitle}</p>
  </div>
</section>

<style lang="scss">
  @import './pricing-hero.scss';
</style>